import appAxios from "../services/axios";

export const getSkillsDescriptions = async () => {
  const res = await appAxios.get("/api/skills");
  return res.data;
};
